import classNames from 'classnames';
import escape from 'lodash/escape';
import {hasGalleryText} from './gallery-items';

export const getCaption = (item, category) => {
    const heading = [category?.title, item.title].filter(value => typeof value === 'string' && value.trim()).map(escape).join(' / ');
    const text = hasGalleryText(item.text) ? item.text : '';
    if (!heading && !text) return '';
    return `<div class="mx-auto max-w-xl">${
        heading ? `<div class="font-semibold">${heading}</div>` : ''}${
        text ? `<div class="rich-text mt-2 leading-snug text-center">${text}</div>` : ''}</div>`;
};

export const Caption = ({item, truncate = true, compact = false}) => {
    const title = typeof item.title === 'string' ? item.title.trim() : '';
    const text = hasGalleryText(item.text) ? item.text : '';
    return title || text ? <div className="p-2">
        {title ? <div className={classNames('font-semibold leading-snug', compact && 'line-clamp-2')}>{title}</div> : null}
        {text ? <div dangerouslySetInnerHTML={{__html: text}} className={classNames('rich-text leading-snug', truncate && 'line-clamp-2')}/> : null}
    </div> : null;
};
